<template>
    <st-filters-pagination
        stateModule="administrator/urbanismRegulationZonesList"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :header="$t('URBANISM_REGULATION_ZONES.LIST.TITLE')"
        :moreFilters="false"
        :showErase="false"
    >
        <template #filters-toolbar>
            <slot name="toolbar">
            </slot>
        </template>

        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { UrbanismRegulationZonesModel } from '@/modules/administrator/models/urbanism-regulation-zones-model';

    const { fields } = UrbanismRegulationZonesModel;

    const filterSchema = new FilterSchema([
        fields.name,
        fields.key,
        fields.tenant_id,
        fields.type,
    ]);

    export default {
        name: 'UrbanismRegulationsListFilter',
        data() {
            return {
                filters: filterSchema.fields,
                currentPage: 1,
            };
        },
        computed: {
            ...mapGetters({
               total: 'administrator/urbanismRegulationZonesList/total',
            }),
        },
        methods: {
            ...mapActions({
                doFetch: 'administrator/urbanismRegulationZonesList/doFetch',
            }),
            refresh() {
                this.doFilter(this.params);
            },
            async doFilter(params) {
                this.params = params;
                this.doFetch(params);
            },
        },

    };
</script>

<style scoped>

</style>

